import { type SubscriptionHookOptions, useSubscription } from "@apollo/client";
import { ContentStatusChangedSubscription } from "../graphql/subscriptions";
import type { ContentStatusChangedSubscriptionType } from "@/types/graphql/partner.generated";

export const useContentStatusChangedSubscription = (
  options?: SubscriptionHookOptions<ContentStatusChangedSubscriptionType>
) => {
  return useSubscription<ContentStatusChangedSubscriptionType>(
    ContentStatusChangedSubscription,
    options
  );
};
